const cleanAuthors = (authors: string[] = []): string =>
  authors.map((a) => a.trim()).join(', ')

export default cleanAuthors
